import React, { useState, useEffect } from 'react';
import './Dashboard.css';
import api from '../utils/api';

function Dashboard({ onLogout }) {
  const [text, setText] = useState('');
  const [newText, setNewText] = useState('');
  const [loading, setLoading] = useState(true);
  const [updating, setUpdating] = useState(false);
  const [message, setMessage] = useState('');

  useEffect(() => {
    fetchText();
  }, []);

  const fetchText = async () => {
    try {
      setLoading(true);
      const response = await api.get('/text');
      setText(response.data.content);
      setNewText(response.data.content);
    } catch (error) {
      console.error('Error fetching text:', error);
      setMessage('Error loading text');
    } finally {
      setLoading(false);
    }
  };

  const handleUpdate = async (e) => {
    e.preventDefault();
    if (!newText.trim()) {
      setMessage('Text cannot be empty');
      return;
    }

    try {
      setUpdating(true);
      setMessage('');
      const response = await api.put('/text', { content: newText });
      setText(response.data.content);
      setMessage('Text updated successfully!');
      setTimeout(() => setMessage(''), 3000);
    } catch (error) {
      console.error('Error updating text:', error);
      setMessage(error.response?.data?.error || 'Error updating text');
    } finally {
      setUpdating(false);
    }
  };

  return (
    <div className="dashboard-container">
      <div className="dashboard-card">
        <div className="dashboard-header">
          <h1>Dashboard</h1>
          <button onClick={onLogout} className="logout-button">
            Logout
          </button>
        </div>

        <div className="content-section">
          <h2>Displayed Text</h2>
          {loading ? (
            <div className="loading-text">Loading...</div>
          ) : (
            <div className="display-text">{text || 'Hello World'}</div>
          )}
        </div>

        <div className="update-section">
          <h2>Update Text</h2>
          <form onSubmit={handleUpdate}>
            <textarea
              value={newText}
              onChange={(e) => setNewText(e.target.value)}
              placeholder="Enter new text..."
              rows="4"
              className="text-input"
            />
            {message && (
              <div className={`message ${message.includes('Error') ? 'error' : 'success'}`}>
                {message}
              </div>
            )}
            <button type="submit" className="update-button" disabled={updating}>
              {updating ? 'Updating...' : 'Update Text'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}

export default Dashboard;

